import { parseDuration } from './parseDuration';

export const shouldPromptAgain = (promptFrequency: string) => {
  const dismissedAt = window.localStorage.getItem('pushPromptDismissedAt');
  if (!dismissedAt) return true;

  return Date.now() - parseInt(dismissedAt) >= parseDuration(promptFrequency);
};
